import { render, staticRenderFns } from "./AboutItemLeft.vue?vue&type=template&id=5cd7417e&"
import script from "./AboutItemLeft.vue?vue&type=script&lang=js&"
export * from "./AboutItemLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports